import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { AuthenticationTypes, AuthenticationProperties } from 'app/security/core/enums/authentication-types.enum';

@Component({
    selector: 'auth-form-fields',
    templateUrl: './auth-form-fields.component.html',
    styleUrls: ['./auth-form-fields.component.scss']
})
export class AuthFormFieldsComponent implements OnChanges {
    subType: string = '';
    type: string = '';
    selectedMethod: any;
    
    @Input() authenticator: any;
    @Input() metadata: any;
    @Input() placeholder: string = '';
    @Input() disabled: boolean = false;
    @Input() showDisplayName: boolean = false;
    @Input() layout: 'single' | 'double' = 'single'; // New layout parameter
    @Input() enableNewTabAuthentication: any;
    @Input() selectedMultipleAuthenticator: any;

    @Output() typeChange = new EventEmitter<string>();
    @Output() subtypeChange = new EventEmitter<string>();
    @Output() flowChange = new EventEmitter<string>();

    // ==================== GETTERS ====================
    get subtypes(): any[] {
        if (this.selectedMethod?.type && this.metadata?.[this.selectedMethod.type]?.[AuthenticationProperties.CONFIG]?.[AuthenticationProperties.SUBTYPES]?.[AuthenticationProperties.OPTIONS]) {
            return this.metadata[this.selectedMethod.type][AuthenticationProperties.CONFIG][AuthenticationProperties.SUBTYPES][AuthenticationProperties.OPTIONS];
        }
        return [];
    }

    get flows(): any[] {
        if (this.selectedMethod?.type === AuthenticationTypes.OAUTH2 &&
            this.selectedMethod?.subtype &&
            this.metadata?.[this.selectedMethod.type]?.[AuthenticationProperties.CONFIG]?.[AuthenticationProperties.FLOWS]?.[AuthenticationProperties.OPTIONS]?.[this.selectedMethod.subtype]?.[AuthenticationProperties.OPTIONS]) {
            return this.metadata[this.selectedMethod.type][AuthenticationProperties.CONFIG][AuthenticationProperties.FLOWS][AuthenticationProperties.OPTIONS][this.selectedMethod.subtype][AuthenticationProperties.OPTIONS];
        }
        return [];
    }

    get activeFlow(): any {
        if (this.selectedMethod?.oauthOptions?.[AuthenticationProperties.ACTIVE_FLOW]) {
            return this.selectedMethod.oauthOptions[AuthenticationProperties.ACTIVE_FLOW];
        }
        if (this.selectedMethod?.activeFlow) {
            return this.selectedMethod.activeFlow;
        }
        return '';
    }
    // ==================== END GETTERS ====================

    ngOnChanges(): void {
        if (this.authenticator) {
            this.selectedMethod =  this.selectedMultipleAuthenticator ? this.selectedMultipleAuthenticator : this.authenticator;
            this.subType = this.selectedMethod?.subtype || '';
        }
    }

    // ==================== EVENT HANDLERS ====================
    onTypeChange(type: string) {
        this.type = type;
        this.typeChange.emit(type);
    }

    onSubtypeChange(subtype: string) {
        this.subtypeChange.emit(subtype);
    }

    onFlowChange(flow: string) {
        if (this.selectedMethod.oauthOptions) {
            this.selectedMethod.oauthOptions[AuthenticationProperties.ACTIVE_FLOW] = flow;
        }
        this.flowChange.emit(flow);
    }
    // ==================== END EVENT HANDLERS ====================

    // ==================== UTILITY METHODS ====================
    getFilteredMetadata(): any {
        if (!this.metadata) {
            return {};
        }

        // If layout is double (multiple authenticator creation), exclude the "Multiple" type
        if (this.layout === 'double') {
            const filtered = { ...this.metadata };
            delete filtered[AuthenticationTypes.MULTIPLE];
            return filtered;
        }

        // For single layout, return all metadata
        return this.metadata;
    }
    // ==================== END UTILITY METHODS ====================
}